import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useDeleteUserGroupMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ userGroupId }: { userGroupId: string }) => {
			return userSession.webServiceHelper.callAsync<void>(`userGroup/${userGroupId}`, 'DELETE', null);
		},
		onError,
		onSuccess,
	});
}
